import React, { useState, useEffect, useRef } from 'react';
import HighchartsReact from 'highcharts-react-official';
import Highcharts from 'highcharts';
import HighchartsMore from 'highcharts/highcharts-more';
import HC_exporting from 'highcharts/modules/exporting';
import ptBr from '@app/i18n/ptBR/index';
import { GraficoAreaExecutiveSummaryResumoCapExResult } from '@app/api/areaExecutiveSummary';
HighchartsMore(Highcharts);
HC_exporting(Highcharts);

interface AreaExecutiveSummaryResumoCapExProps {
  grafico: GraficoAreaExecutiveSummaryResumoCapExResult;
}

const AreaExecutiveSummaryResumoCapEx = ({ grafico }: AreaExecutiveSummaryResumoCapExProps) => {
  const chartRef = useRef(null);

  const removerSimboloNegativo = (valor: string) => {
    return valor.replace('-', '');
  };

  const chartOptions = {
    chart: {
      type: 'waterfall',
    },

    title: {
      text: `${''}`,
    },

    xAxis: {
      type: 'category',
    },

    yAxis: {
      title: {
        text: 'BRL',
      },
    },

    legend: {
      enabled: false,
    },

    plotOptions: {
      series: {
        lineWidth: 0,
        borderWidth: 0,
      },
    },

    tooltip: {
      pointFormat: '<b> R$ {point.y:,.2f} </b> BRL',
    },

    series: [
      {
        data: [
          {
            name: `${ptBr.capex}`,
            y: grafico.capEx,
            color: '#08340D',
          },
          {
            name: `${ptBr.contratado}`,
            dataLabels: {
              enabled: false,
            },
            y: grafico.contHidden,
            visible: false,
          },
          {
            name: `${ptBr.contratado}`,
            isSum: true,
            color: '#006129',
          },
          {
            name: `${ptBr.executado}`,
            dataLabels: {
              enabled: false,
            },
            y: grafico.execuHidden,
            visible: false,
          },
          {
            name: `${ptBr.executado}`,
            isIntermediateSum: true,
            color: '#80BDA6',
          },
          {
            name: `${ptBr.requisitado}`,
            visible: false,
            dataLabels: {
              enabled: false,
            },
            y: grafico.reqsHidden,
          },
          {
            name: `${ptBr.requisitado}`,
            y: grafico.reqs,
            color: '#E1865C',
          },
          {
            name: `${ptBr.aContratar}`,
            visible: false,
            dataLabels: {
              enabled: false,
            },
            y: grafico.toContHidden,
          },
          {
            name: `${ptBr.aContratar}`,
            y: grafico.toCont,
            color: '#FFA357',
          },
          {
            name: `${ptBr.forecast}`,
            isSum: true,
            color: '#8C0400',
          },
          {
            name: `${ptBr.saldoCapex}`,
            y: grafico.sadoCapex,
            color: '#FFA357',
          },
        ],
        dataLabels: {
          enabled: true,
          formatter: function () {
            return removerSimboloNegativo(this.y.toLocaleString('pt-br', { minimumFractionDigits: 1 }));
          },
          verticalAlign: 'top',
        },
        pointPadding: 0,
      },
    ],
  };

  return grafico ? (
    <>
      <HighchartsReact ref={chartRef} highcharts={Highcharts} options={chartOptions} />
    </>
  ) : (
    <></>
  );
};

export default AreaExecutiveSummaryResumoCapEx;
